import { Box, Grid, Stack, Select, FormControl, MenuItem } from '@mui/material';
import AchievableColorTable from './achievableColorTable';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function TargetColorSection(props) {
  let { colorCategoryOptions, resultOptions , achievableColorTablerows} = props.targetColorData;
  return (
    <Box>
      {/* <Stack direction="row" spacing={3} sx={{ paddingBottom: '24px' }}>
        <Box>
          <span className="font-16 font-weight-600 line-height-40">
            Color Cat.
          </span>
          <FormControl>
            <Select
              value={'All'}
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                margin: '0px 8px',
                fontFamily: 'Source Sans Pro',
                color: '#313131',
                fontSize: '16px',
                fontWeight: '400',
                height: '36px',
                minWidth: '75px',
                width: '100%',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '0px !important',
                },
                '& .MuiSvgIcon-root': { color: '#3793D5', marginRight: '2px' },
              }}
            >
              {colorCategoryOptions?.map((e) => {
                return (
                  <MenuItem
                    sx={{
                      borderBottomColor: '#C7C9C7',
                    }}
                    key={e}
                    value={e}
                  >
                    {' '}
                    {e}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
        <Box>
          <span className="font-16 font-weight-600 line-height-40">Result</span>
          <FormControl>
            <Select
              value={'All'}
              IconComponent={KeyboardArrowDownIcon}
              displayEmpty
              sx={{
                margin: '0px 8px',
                fontFamily: 'Source Sans Pro',
                color: '#313131',
                fontSize: '16px',
                fontWeight: '400',
                height: '36px',
                minWidth: '75px',
                width: '100%',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '0px !important',
                },
                '& .MuiSvgIcon-root': { color: '#3793D5', marginRight: '2px' },
              }}
            >
              {resultOptions?.map((e) => {
                return (
                  <MenuItem
                    sx={{
                      borderBottomColor: '#C7C9C7',
                    }}
                    key={e}
                    value={e}
                  >
                    {' '}
                    {e}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </Stack> */}
      <Box>
        <AchievableColorTable achievableColorTablerows={achievableColorTablerows} />
      </Box>
    </Box>
  );
}
